import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export interface StateAction {
    label: string;
    // 既存 route への遷移先のみ。新規副作用・API 呼び出しは持たせない。
    to: string;
}

export interface StatePanelProps {
    image: string;
    imageAlt?: string;
    message: string;
    actions?: StateAction[];
    height?: number;
}

// 空 / エラー状態の共通パネル（画像 + 文言 + 既存 route への CTA）。
// 状態判定や副作用は持たず、表示と遷移のみを担う。
export const StatePanel: React.FC<StatePanelProps> = ({
    image,
    imageAlt = '',
    message,
    actions,
    height = 360,
}) => (
    <Box display="flex" flexDirection="column" alignItems="center" mt={4} gap={1.5}>
        <img src={image} alt={imageAlt} height={height} style={{ maxWidth: '100%' }} />
        <Typography align="center" variant="body1">{message}</Typography>
        {actions && actions.length > 0 && (
            <Stack direction="row" spacing={1.5} mt={1} flexWrap="wrap" justifyContent="center">
                {actions.map((action) => (
                    <Button
                        key={`${action.to}:${action.label}`}
                        variant="contained"
                        component={RouterLink}
                        to={action.to}
                    >
                        {action.label}
                    </Button>
                ))}
            </Stack>
        )}
    </Box>
);
